import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { UsersApiAdapter } from '../adapters/UsersApiAdapter';

export const useUsers = () => {
    const usersApiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new UsersApiAdapter(httpClient);
    }, []);

    const { data: users = [], isLoading: loading, error } = useQuery({
        queryKey: ['users-team'],
        queryFn: async () => {
            return usersApiAdapter.getAll();
        },
        staleTime: 5 * 60 * 1000, // 5 minutos
    });

    return {
        users,
        loading,
        error,
    };
};

